<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <h4>Detalle de subsección</h4>
    <hr>
    <div class="col-12">

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Orden</label>
            <input class="form-control" type="text" formControlName="order" autocomplete="off"
                [class.is-invalid]="campoNoValido('order')">
            <small class="text-danger" *ngIf="campoNoValido('order')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Título de subsección</label>
            <input class="form-control" type="text" formControlName="title" autocomplete="off"
                [class.is-invalid]="campoNoValido('title')">
            <small class="text-danger" *ngIf="campoNoValido('title')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Contenido</label>
            <textarea class="form-control" formControlName="content" [class.is-invalid]="campoNoValido('content')"
                rows="5"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('content')">Este campo es requerido</small>
            <br>
            <div class="small-message">
                <p>Para añadir un enlace externo en el contenido copie el siguiente bloque en donde corresponda y
                    reemplace el <b>url_destino</b> y <b>texto_a_enlazar</b>. Asegúrese que los datos sean válidos.
                </p>
                <p class="text-center"><b>{{linkString}}</b></p>
            </div>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Visible/oculto</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                </div>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <ng-container *ngIf="!isSectionBlocked">
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </ng-container>
            </div>
        </div>
    </div>

</form>